import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
var _excluded = ["className", "spacing", "style", "children", "justify", "align", "reverse", "wrap", "fullWidth", "span", "breakpoints", "jss"];
import React from 'react';
import cn from 'classnames';
import createStyles from "../../createStyles";
import { firstLetterUppercase as capitalize } from "../../utils";
import styles, { generateMediaSupport, generateSpacing, spacing as spacingArray } from "../styles";
export var useStyles = createStyles(function (theme) {
  var breakpoints = generateMediaSupport(theme.breakpoints);
  var spacing = generateSpacing(theme.spacer, spacingArray);
  return _extends({
    root: {
      display: 'flex'
    },
    flexDirectionColumn: {
      flexDirection: 'column'
    },
    flexDirectionColumnReverse: {
      flexDirection: 'column-reverse'
    }
  }, styles, breakpoints, spacing);
}, {
  name: 'Col'
});
var Col = /*#__PURE__*/React.forwardRef(function Col(_ref, ref) {
  var _cn;

  var className = _ref.className,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 0 : _ref$spacing,
      style = _ref.style,
      children = _ref.children,
      _ref$justify = _ref.justify,
      justify = _ref$justify === void 0 ? 'start' : _ref$justify,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'stretch' : _ref$align,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      _ref$wrap = _ref.wrap,
      wrap = _ref$wrap === void 0 ? false : _ref$wrap,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      _ref$span = _ref.span,
      span = _ref$span === void 0 ? 0 : _ref$span,
      breakpoints = _ref.breakpoints,
      _ref$jss = _ref.jss,
      jss = _ref$jss === void 0 ? {} : _ref$jss,
      props = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles({
    jss: jss
  });

  var _ref2 = breakpoints || {},
      xs = _ref2.xs,
      sm = _ref2.sm,
      md = _ref2.md,
      lg = _ref2.lg,
      xl = _ref2.xl,
      xlg = _ref2.xlg;

  var xsSize = span || xs;
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    ref: ref,
    className: cn(classes.root, (_cn = {}, _defineProperty(_cn, classes.flexWrap, wrap), _defineProperty(_cn, classes["spacing".concat(spacing)], spacing), _defineProperty(_cn, classes.fullWidth, fullWidth), _defineProperty(_cn, classes.flexDirectionColumn, !reverse), _defineProperty(_cn, classes.flexDirectionColumnReverse, reverse), _defineProperty(_cn, classes["justify".concat(capitalize(justify))], justify !== 'start'), _defineProperty(_cn, classes["alignItems".concat(capitalize(align))], align !== 'stretch'), _defineProperty(_cn, classes["col-xs-".concat(xsSize)], xsSize), _defineProperty(_cn, classes["col-sm-".concat(sm)], sm), _defineProperty(_cn, classes["col-md-".concat(md)], md), _defineProperty(_cn, classes["col-lg-".concat(lg)], lg), _defineProperty(_cn, classes["col-xl-".concat(xl)], xl), _defineProperty(_cn, classes["col-xlg-".concat(xlg)], xlg), _cn), 'col-wrapper', className),
    style: style
  }), children);
}); // Hack for withInfo plugin

Col.displayName = 'Col';
export default Col;